export const classes = {
  wrapper: 'flex flex-col items-center',
  iconWrapper:
    'upload-icon-wrapper bg-white dark:bg-[#332e43] shadow-lg mb-2 text-blue-3 rounded-xl p-3 transition-all',
  title: 'pointer-events-none text-inherit select-none',
  subtitle: 'pointer-events-none font-light text-base select-none',
};
